import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import frCommon from "./translations/fr/common.json";
import frDashboard from "./translations/fr/dashboard.json";

import enCommon from "./translations/en/common.json";
import enDashboard from "./translations/en/dashboard.json";

import arCommon from "./translations/ar/common.json";
import arDashboard from "./translations/ar/dashboard.json";

import esCommon from "./translations/es/common.json";
import esDashboard from "./translations/es/dashboard.json";
import ptCommon from "./translations/pt/common.json";
import ptDashboard from "./translations/pt/dashboard.json";
import zhCommon from "./translations/zh/common.json";
import zhDashboard from "./translations/zh/dashboard.json";
import deCommon from "./translations/de/common.json";
import deDashboard from "./translations/de/dashboard.json";
import ruCommon from "./translations/ru/common.json";
import ruDashboard from "./translations/ru/dashboard.json";
import itCommon from "./translations/it/common.json";
import itDashboard from "./translations/it/dashboard.json";
import srCommon from "./translations/sr/common.json";
import srDashboard from "./translations/sr/dashboard.json";

const supportedLanguages = [
    "fr",
    "en",
    "ar",
    "es",
    "pt",
    "zh",
    "de",
    "ru",
    "it",
    "sr"
];

const browserLanguage =
    navigator.language
        ?.split("-")[0]
        ?.toLowerCase();

const defaultLanguage =
    supportedLanguages.includes(
        browserLanguage
    )
        ? browserLanguage
        : "en";

const language =
    localStorage.getItem(
        "siteLanguage"
    ) || defaultLanguage;

i18n
    .use(initReactI18next)

    .init({

        resources: {

            fr: {
                translation: {
                    ...frCommon,
                    ...frDashboard
                }
            },

            en: {
                translation: {
                    ...enCommon,
                    ...enDashboard
                }
            },

            ar: {
                translation: {
                    ...arCommon,
                    ...arDashboard
                }
            },

            es: {
                translation: {
                    ...esCommon,
                    ...esDashboard
                }
            },

            pt: { translation: { ...ptCommon, ...ptDashboard } },
            zh: { translation: { ...zhCommon, ...zhDashboard } },
            de: { translation: { ...deCommon, ...deDashboard } },
            ru: { translation: { ...ruCommon, ...ruDashboard } },
            it: { translation: { ...itCommon, ...itDashboard } },
            sr: { translation: { ...srCommon, ...srDashboard } }

        },

        lng: language,

        fallbackLng: "en",

        interpolation: {
            escapeValue: false
        }

    });

export default i18n;


// import i18n from "i18next";
// import { initReactI18next } from "react-i18next";

// import frCommon from "./translations/fr/common.json";
// import frDashboard from "./translations/fr/dashboard.json";

// import enCommon from "./translations/en/common.json";
// import enDashboard from "./translations/en/dashboard.json";

// import arCommon from "./translations/ar/common.json";
// import arDashboard from "./translations/ar/dashboard.json";

// import esCommon from "./translations/es/common.json";
// import esDashboard from "./translations/es/dashboard.json";

// const language =
//     localStorage.getItem(
//         "siteLanguage"
//     ) || "fr";

// i18n
//     .use(initReactI18next)

//     .init({

//         resources: {

//             fr: {
//                 translation: {
//                     ...frCommon,
//                     ...frDashboard
//                 }
//             },

//             en: {
//                 translation: {
//                     ...enCommon,
//                     ...enDashboard
//                 }
//             },

//             ar: {
//                 translation: {
//                     ...arCommon,
//                     ...arDashboard
//                 }
//             },

//             es: {
//                 translation: {
//                     ...esCommon,
//                     ...esDashboard
//                 }
//             }

//         },

//         lng: language,

//         fallbackLng: "fr",

//         interpolation: {
//             escapeValue: false
//         }

//     });

// export default i18n;
